import { render, staticRenderFns } from "./PackagingDialog.vue?vue&type=template&id=ab3e22b0&scoped=true"
import script from "./PackagingDialog.vue?vue&type=script&lang=js"
export * from "./PackagingDialog.vue?vue&type=script&lang=js"
import style0 from "./PackagingDialog.vue?vue&type=style&index=0&id=ab3e22b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3e22b0",
  null
  
)

export default component.exports